import React from 'react';
import { products } from '../data/products';
import ProductCard from './ProductCard';

function TowelDryers({ onProductClick, lang }) {
  return (
    <section id="towel-dryers" className="towel-dryers">
      <div className="container">
        <h2 className="section-title">
          {lang === 'it' ? 'Scaldasalviette' : 'Полотенцесушители'}
        </h2>
        <p className="section-subtitle">
          {lang === 'it'
            ? 'Scaldasalviette in vetro premium con controllo WiFi'
            : 'Премиальные стеклянные полотенцесушители с WiFi управлением'
          }
        </p>

        <div className="products-grid">
          {products.towelDryers.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onClick={onProductClick}
              lang={lang}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TowelDryers;
